export const CATEGORY_LABELS = {
  "road-safety": "Road safety",
  visualization: "Visualization",
  "public-involvement": "Public involvement",
  company: "Company",
};
